import React from 'react'
import DetalleRemitoCompra from '../../Componentes/DetalleRemitoCompra'

function DetalleRemitoCompraPage() {
    return (
        <div>
            <DetalleRemitoCompra />
        </div>
    )
}

export default DetalleRemitoCompraPage